import axios from 'axios'

export const getPartner = (partnerId: string) => {
  return axios.get('/data/sadarbības_partneris/' + partnerId).then((resp) => resp.data)
}
